/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: var(--nve-ref-size-300) var(--nve-ref-size-400);
  padding: var(--padding);
  color: var(--color);
  flex-grow: 1;
  width: 100%;
  contain: none;
}

::slotted(nve-menu) {
  --width: 100%;
}
